export default __webpack_public_path__ + "static/mobile-petites-annonces-db7c7afc84e8940179b0854587243ade.png";